export const PRIVATE = "PRIVATE";
export const SHARED = "SHARED";
